<footer class="main-footer" dir="rtl">
  <!-- Contact Us Card (الكارت الأخضر العلوي) -->
  <div class="contact-us-wrapper">
    <div class="contact-us-card" style = "margin-bottom: 20px">
      <div class="contact-content">
        <h3 class="text-center">تواصل معنا</h3>

        <div class="contact-info">
          <div class="info-item">
            <i class="fas fa-map-marker-alt"></i>
            <span>3, شارع صلاح سالم، مدينة نصر، القاهرة، 11562 مصر</span>
          </div>
          <div class="info-item">
            <i class="fa-solid fa-phone"></i>
            <span>202-240-55-425+</span>
          </div>
          <div class="info-item">
            <i class="fa-solid fa-fax"></i>
            <span>202-240-55-425+</span>
          </div>
          <div class="info-item">
            <i class="fa-solid fa-fax"></i>
            <span>202-16035+</span>
          </div>
        </div>

        <div class="social-media">
          <a href="#" class="social-link"><i class="fab fa-facebook-f"></i></a>
          <a href="#" class="social-link"><i class="fab fa-twitter"></i></a>
          <a href="#" class="social-link"><i class="fab fa-instagram"></i></a>
          <a href="#" class="social-link"><i class="fab fa-youtube"></i></a>
          <a href="#" class="social-link"><i class="fab fa-linkedin-in"></i></a>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Links Section -->
  <div class="footer-links-section">
    <div class="container">
      <div class="row g-4">
        <!-- القوائم -->
        <div class="col-12 col-sm-6 col-lg-2">
          <h5>المساعدة</h5>
          <ul>
            <li><a href="#">مركز خدمات المستثمرين</a></li>
            <li><a href="#">شركات المسئوليه المحدوده</a></li>
            <li><a href="#">الأسئلة الشائعة</a></li>
          </ul>
        </div>
        <div class="col-12 col-sm-6 col-lg-2">
          <h5>القطاعات</h5>
          <ul>
            <li><a href="#">اتفاقيات التجارة</a></li>
            <li><a href="#">القطاعات المستهدفة</a></li>
          </ul>
        </div>
        <div class="col-12 col-sm-6 col-lg-2">
          <h5>ابدأ مشروعك</h5>
          <ul>
            <li><a href="#">أنظمة الاستثمار</a></li>
            <li><a href="#">تأسيس الأعمال التجارية</a></li>
            <li><a href="#">الحقائق التجارية</a></li>
          </ul>
        </div>
        <div class="col-12 col-sm-6 col-lg-2">
          <h5>المركز الإعلامي</h5>
          <ul>
            <li><a href="#">الأخبار</a></li>
            <li><a href="#">البيانات الصحفية</a></li>
            <li><a href="#">معرض الفيديو</a></li>
          </ul>
        </div>
        <div class="col-12 col-sm-6 col-lg-2">
          <h5>لماذا مصر؟</h5>
          <ul>
            <li><a routerLink="/whyEgypt">عن مصر</a></li>
            <li><a routerLink="/indicators">المؤشرات الاقتصادية</a></li>
            <li><a routerLink="/success">قصص النجاح</a></li>
          </ul>
        </div>
      </div>

      <hr class="footer-divider">

      <div class="quick-links text-center">
        <a href="#">فرص العمل</a>
        <a href="#">مواقع مقترحة</a>
        <a href="#">البيانات الصحفية</a>
        <a href="#">اتصل بنا</a>
        <a href="#">عن الهيئة</a>
      </div>

      <p class="copyright text-center">
        © 2019 - 2025 جميع الحقوق محفوظة للهيئة العامة للاستثمار والمناطق الحرة
      </p>
    </div>
  </div>
</footer>